import { useCallback, createContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UnblockHistoryContext = /*#__PURE__*/createContext({
  unblockHistory: () => {},
  updateUnblockFunction: () => {}
});
export const UnblockHistoryConsumer = UnblockHistoryContext.Consumer;
export const UnblockHistoryProvider = ({
  children
}) => {
  const [unblockHistory, setUnblockHistory] = useState(() => () => {});
  const updateUnblockFunction = useCallback(unregisterCallback => {
    setUnblockHistory(() => unregisterCallback);
  }, [setUnblockHistory]);
  return /*#__PURE__*/_jsx(UnblockHistoryContext.Provider, {
    value: {
      unblockHistory,
      updateUnblockFunction
    },
    children: children
  });
};
export function wireUnblockHistoryConsumer(WrappedComponent) {
  return props => /*#__PURE__*/_jsx(UnblockHistoryConsumer, {
    children: ({
      unblockHistory,
      updateUnblockFunction
    }) => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      unblockHistory: unblockHistory,
      updateUnblockFunction: updateUnblockFunction
    }))
  });
}